import { Project, TaskId } from '@/model/types'

export function bannedPrereqs (project: Project, task: TaskId): Set<TaskId> {
  const banned = new Set<TaskId>()

  // Add all dependencies and self
  function addDependents (task: TaskId) {
    if (banned.has(task)) return
    banned.add(task)
    Object.values(project.dependencies).forEach(d => {
      if (d.prereq === task) addDependents(d.dependent)
    })
  }
  addDependents(task)

  // Add immediate prerequisites
  Object.values(project.dependencies).forEach(d => {
    if (d.dependent === task) banned.add(d.prereq)
  })

  return banned
}

export function bannedDependencies (project: Project, task: TaskId): Set<TaskId> {
  const banned = new Set<TaskId>()

  // Add all prerequisites and self
  function addPrereqs (task: TaskId) {
    if (banned.has(task)) return
    banned.add(task)
    Object.values(project.dependencies).forEach(d => {
      if (d.dependent === task) addPrereqs(d.prereq)
    })
  }
  addPrereqs(task)

  // Add immediate dependents
  Object.values(project.dependencies).forEach(d => {
    if (d.prereq === task) banned.add(d.dependent)
  })

  return banned
}
